module.exports = __webpack_public_path__ + "static/WelcomeToElk6-ed019bd547151f4bb52869215e6c8a60.webp";